export default {"src":"/_next/static/media/mode_friend.6d2ffa75.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};